import React, { Suspense } from "react";
import { Switch } from "react-router-dom";
import { Spinner } from "@abb/abb-common-ux-react";
// grade
import Grade from "../grade/Index";
import GradeViewAll from "../grade/ViewAll";
import GradeForm from "../grade/Form";
import AssociateGradeProperty from "../grade/AssociateProperty";

// Instrument Type
import InstrumentType from "../instrumentType/Index";
import CreateInstrumentType from "../instrumentType/Form";
import InstrumentTypeViewAll from "../instrumentType/ViewAll";
import AssociateInstrumentTypeProperty from "../instrumentType/AssociateProperty";

// Instrument
import Instrument from "../instrument/Index";
import CreateInstrument from "../instrument/Form";
import InstrumentViewAll from "../instrument/ViewAll";

// Testplan
import Testplan from "../testplan/Index";
import CreateTestplan from "../testplan/Form";
import TestplanViewAll from "../testplan/ViewAll";

// Sample
import SampleNew from "../sampleNew/Index";
import MeasurementLanding from "../sample/MeasurementIndex";
import FormNew from "../sampleNew/Form";

//role&permissions
import RolesAndPermissions from "../rolesandpermissions/Index";
import CreateRole from "../rolesandpermissions/Form";

// Account Management
import UserIndex from "../user/Index";
import CreateUser from "../user/Form";

//Scanner
import ScannerIndex from "../scanner/Index";
import ScannerCreate from "../scanner/Form";
import ScannerViewall from "../scanner/ViewAll";

// for layout change
import StationForm from "../station/Form";
import Station from "../station/Index";
import StationViewAll from "../station/ViewAll";
import PropertyForm from "../property/Form";
import Property from "../property/Index";
import PropertyViewAll from "../property/ViewAll";
import ProductForm from "../product/Form";
import Product from "../product/Index";
import ProductViewAll from "../product/ViewAll";
import SourceForm from "../source/Form";
import Source from "../source/Index";
import SourceViewAll from "../source/ViewAll";
import AppRoutes from "./AppRoutes";
import Dashboard from "../dashboard/Index";

// layouts
import MainLayout from "./MainLayout";
import * as CONSTANTS from "../../utilities/Constants";

import ReportIndex from "../reportTemplate/Index";
import CreateReport from "../reportTemplate/Form";

// login
import Login from "../login/Login";
import LoginLayout from "../login/LoginLayout";
import SampleNewViewAll from "../sampleNew/ViewAll";
// import ReportSample from "../sample/Report";
import Report from "../sample/Report";

import { MEASUREMENT_OVERVIEW_URL } from "../../utilities/Constants";
import MeasurementOverviewIndex from "../sample/MeasurementOverviewIndex";
import UserViewAll from "../user/VIewAll";

//backup and restore
import Utility from "../backupAndRestore/Index";
import Setting from "../setting/Index";

// instrument dashboard
import InstrumentDashboard from "../instrumentDashboard/Index";
import Trends from "../trends/Index";

import MainLayoutNew from "../sharedNew/MainLayout";

import ManageInstrumentIndex from "../manageInstrument";

//LOGS
import Logs from "../logs";

import LicenseManagement from "../licenseManagement";

export const Routes: React.FC = () => {
  return (
    <Suspense fallback={<div className="loader d-flex align-items-center justify-content-center"><Spinner sizeClass="large" /></div>}>
      <Switch>
        <AppRoutes
          path={CONSTANTS.LOGIN_URL}
          exact={true}
          component={Login}
          layout={LoginLayout}
        />
        <AppRoutes
          path="/"
          exact={true}
          component={Login}
          layout={LoginLayout}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_GRADE]}
          path={CONSTANTS.GRADE_INDEX_URL}
          exact={true}
          component={Grade}
          layout={MainLayoutNew}
        />
        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_GRADE+":ViewAll"]}
          path={CONSTANTS.GRADE_VIEW_ALL}
          exact={true}
          component={GradeViewAll}
          layout={MainLayoutNew}
        />
        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_GRADE+":Add",CONSTANTS.AUTHKEY_GRADE+":Edit"]}
          path={CONSTANTS.GRADE_CREATE_URL}
          exact={true}
          component={GradeForm}
          layout={MainLayoutNew}
        />
        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_GRADE]}
          path={CONSTANTS.GRADE_ASSOCIATE_PROPERTY_URL}
          exact={true}
          component={AssociateGradeProperty}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_PROPERTY]}
          path={CONSTANTS.PROPERTY_INDEX_URL}
          exact={true}
          component={Property}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_PROPERTY+":Add",CONSTANTS.AUTHKEY_PROPERTY+":Edit"]}
          path={CONSTANTS.PROPERTY_CREATE_URL}
          exact={true}
          component={PropertyForm}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_PROPERTY+":ViewAll"]}
          path={CONSTANTS.PROPERTY_VIEW_ALL}
          exact={true}
          component={PropertyViewAll}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_PRODUCT]}
          path={CONSTANTS.PRODUCT_INDEX_URL}
          exact={true}
          component={Product}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_PRODUCT+":Add", CONSTANTS.AUTHKEY_PRODUCT+":Edit"]}
          path={CONSTANTS.PRODUCT_CREATE_URL}
          exact={true}
          component={ProductForm}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_PRODUCT+":ViewAll"]}
          path={CONSTANTS.PRODUCT_VIEW_ALL}
          exact={true}
          component={ProductViewAll}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SOURCE]}
          path={CONSTANTS.SOURCE_INDEX_URL}
          exact={true}
          component={Source}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SOURCE+":Add",CONSTANTS.AUTHKEY_SOURCE+":Edit"]}
          path={CONSTANTS.SOURCE_CREATE_URL}
          exact={true}
          component={SourceForm}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SOURCE+":ViewAll"]}
          path={CONSTANTS.SOURCE_VIEW_ALL}
          exact={true}
          component={SourceViewAll}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_INSTRUMENT_STATION]}
          path={CONSTANTS.STATION_INDEX_URL}
          exact={true}
          component={Station}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_INSTRUMENT_STATION+":Add",CONSTANTS.AUTHKEY_INSTRUMENT_STATION+":Edit"]}
          path={CONSTANTS.STATION_CREATE_URL}
          exact={true}
          component={StationForm}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_INSTRUMENT_STATION+":ViewAll"]}
          path={CONSTANTS.STATION_VIEW_ALL}
          exact={true}
          component={StationViewAll}
          layout={MainLayoutNew}
        />

        {/* instrument type  */}
        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_INSTRUMENT_TYPE]}
          path={CONSTANTS.INSTRUMENTTYPE_INDEX_URL}
          exact={true}
          component={InstrumentType}
          layout={MainLayoutNew}
        />
        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_INSTRUMENT_TYPE+":Add",CONSTANTS.AUTHKEY_INSTRUMENT_TYPE+":Edit"]}
          path={CONSTANTS.INSTRUMENTTYPE_CREATE_URL}
          exact={true}
          component={CreateInstrumentType}
          layout={MainLayoutNew}
        />
        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_INSTRUMENT_TYPE]}
          path={CONSTANTS.INSTRUMENTTYPE_ASSOCIATE_PROPERTY_URL}
          exact={true}
          component={AssociateInstrumentTypeProperty}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_INSTRUMENT_TYPE+":ViewAll"]}
          path={CONSTANTS.INSTRUMENTTYPE_VIEW_ALL}
          exact={true}
          component={InstrumentTypeViewAll}
          layout={MainLayoutNew}
        />

        {/* Instrument */}
        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_INSTRUMENT]}
          path={CONSTANTS.INSTRUMENT_INDEX_URL}
          exact={true}
          component={Instrument}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_INSTRUMENT+":Add",CONSTANTS.AUTHKEY_INSTRUMENT+":Edit"]}
          path={CONSTANTS.INSTRUMENT_CREATE_URL}
          exact={true}
          component={CreateInstrument}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_INSTRUMENT+":ViewAll"]}
          path={CONSTANTS.INSTRUMENT_VIEW_ALL}
          exact={true}
          component={InstrumentViewAll}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_TEST_PLAN]}
          path={CONSTANTS.TESTPLAN_INDEX_URL}
          exact={true}
          component={Testplan}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_TEST_PLAN+":Add",CONSTANTS.AUTHKEY_TEST_PLAN+":Edit"]}
          path={CONSTANTS.TESTPLAN_CREATE_URL}
          exact={true}
          component={CreateTestplan}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_TEST_PLAN+":ViewAll"]}
          path={CONSTANTS.TESTPLAN_VIEW_ALL}
          exact={true}
          component={TestplanViewAll}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SAMPLE_MODE]}
          path={CONSTANTS.SAMPLE_INDEXNEW_URL}
          exact={true}
          component={SampleNew}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SAMPLE_MODE]}
          path={CONSTANTS.MEASUREMENT_INDEX_URL}
          exact={true}
          component={MeasurementLanding}
          layout={MainLayout}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SAMPLE_MODE]}
          path={MEASUREMENT_OVERVIEW_URL}
          exact={true}
          component={MeasurementOverviewIndex}
          layout={MainLayout}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SAMPLE_MODE]}
          path={CONSTANTS.SAMPLENEW_VIEW_ALL}
          exact={true}
          component={SampleNewViewAll}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_USERS]}
          path={CONSTANTS.USER_INDEX_URL}
          exact={true}
          component={UserIndex}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_USERS+":Add",CONSTANTS.AUTHKEY_USERS+":Edit"]}
          path={CONSTANTS.USER_CREATE_URL}
          exact={true}
          component={CreateUser}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_USERS+":ViewAll"]}
          path={CONSTANTS.USER_VIEW_ALL}
          exact={true}
          component={UserViewAll}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SAMPLE_MODE]}
          path={CONSTANTS.REPORT_INDEX_URL}
          exact={true}
          component={ReportIndex}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SAMPLE_MODE]}
          path={CONSTANTS.REPORT_CREATE_URL}
          exact={true}
          component={CreateReport}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_ROLES]}
          path={CONSTANTS.ROLESANDPERMISSIONS_INDEX_URL}
          exact={true}
          component={RolesAndPermissions}
          layout={MainLayoutNew}
        />

        {/* <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SAMPLE_MODE]}
          path={CONSTANTS.ROLESANDPERMISSIONS_CREATE_URL}
          exact={true}
          component={CreateRole}
          layout={MainLayoutNew}
        /> */}

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SAMPLE_MODE]}
          path={CONSTANTS.SAMPLE_REPORT}
          exact={true}
          component={Report}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SAMPLE_MODE+":Add",CONSTANTS.AUTHKEY_SAMPLE_MODE+":Edit"]}
          path={CONSTANTS.SAMPLE_CREATE_URL_NEW}
          exact={true}
          component={FormNew}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SAMPLE_MODE]}
          path={CONSTANTS.SAMPLENEW_REPORT}
          exact={false}
          component={Report}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_BACKUP_RESTORE]}
          path={CONSTANTS.UTILITY_INDEX_URL}
          exact={true}
          component={Utility}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SAMPLE_MODE]}
          path={CONSTANTS.INSTRUMENT_DASHBOARD_INDEX_URL}
          exact={true}
          component={InstrumentDashboard}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SETTINGS]}
          path={CONSTANTS.UTILITY_SETTING_INDEX_URL}
          exact={true}
          component={Setting}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_TRENDS]}
          path={CONSTANTS.TRENDS_INDEX_URL}
          exact={true}
          component={Trends}
          layout={MainLayoutNew}
        />

        {/* Scanner  */}
        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SCANNER]}
          path={CONSTANTS.SCANNER_INDEX_URL}
          exact={true}
          component={ScannerIndex}
          layout={MainLayoutNew}
        />
        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SCANNER+":Add",CONSTANTS.AUTHKEY_SCANNER+":Edit"]}
          path={CONSTANTS.SCANNER_CREATE_URL}
          exact={true}
          component={ScannerCreate}
          layout={MainLayoutNew}
        />
        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SCANNER+":ViewAll"]}
          path={CONSTANTS.SCANNER_VIEW_ALL}
          exact={true}
          component={ScannerViewall}
          layout={MainLayoutNew}
        />
        {/* <AppRoutes
          path={CONSTANTS.INSTRUMENT_MEASUREMENT_OVERVIEW}
          exact={true}
          component={InstrumentMeasurementIndex}
          layout={MainLayoutNew}
        /> */}

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_INSTRUMENT_MODE]}
          path={CONSTANTS.INSTRUMENT_MEASUREMENT_OVERVIEW}
          exact={true}
          component={ManageInstrumentIndex}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_SAMPLE_MODE]}
          path={CONSTANTS.DASHBOARD_INDEX_URL}
          exact={true}
          component={Dashboard}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_LOGS]}
          path={CONSTANTS.LOGS_INDEX_URL}
          exact={true}
          component={Logs}
          layout={MainLayoutNew}
        />

        <AppRoutes
          authKey={[CONSTANTS.AUTHKEY_LICENSE_MANAGEMENT]}
          path={CONSTANTS.LICENSE_MANAGEMENT_INDEX_URL}
          exact={true}
          component={LicenseManagement}
          layout={MainLayoutNew}
        />
      </Switch>
    </Suspense>
  );
};
